/* tslint:disable */
/* eslint-disable */
/**
 * CAST.AI API documentation
 * ### Feature maturity indicators (may appear on resources, operations and request/response fields)  - **(BETA)** - new or experimental features, subject to change  - **(Deprecated)** - outdated or replaced features (a reason and removal date will be provided in the description) 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Defines workload recommendation rollout types. NO_DISRUPTION - rollout shouldn\'t cause service disruption.
 * @export
 * @enum {string}
 */

export const WorkloadoptimizationV1RolloutBehaviorType = {
    UNSPECIFIED: 'UNSPECIFIED',
    NO_DISRUPTION: 'NO_DISRUPTION'
} as const;

export type WorkloadoptimizationV1RolloutBehaviorType = typeof WorkloadoptimizationV1RolloutBehaviorType[keyof typeof WorkloadoptimizationV1RolloutBehaviorType];



